// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__RE0rU","footer":"ModalError_footer__PJSWa"};